export default __webpack_public_path__ + "static/Fast-e2888a17f9d331b2e0690b8f27e0a16f.gif";